import React from 'react';

// Lightweight atmospheric background with minimal performance impact
export const AtmosphericBackground: React.FC = () => {
  return (
    <div className="fixed inset-0 pointer-events-none overflow-hidden">
      {/* Single static gradient - no animations or JavaScript */}
      <div className="absolute inset-0 bg-gradient-to-br from-cedar-900/3 via-transparent to-forest-900/5"></div>
    </div>
  );
};